import { useMemo, useState } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { FloatingLeftButton } from "@/components/FloatingLeftButton";
import { useCalendarEvents } from "@/lib/hooks/useApi";
import { CalendarHeader } from "./-components/CalendarHeader";
import { CalendarGrid } from "./-components/CalendarGrid";
import { EventDetail } from "./-components/EventDetail";
import ResourceBar from "@/components/ResourceBar";

export const Route = createFileRoute("/(game)/event/")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const [weekOffset, setWeekOffset] = useState(0);
  const [selectedEventId, setSelectedEventId] = useState<string | null>(null);

  const { data: events = [], isLoading, isError } = useCalendarEvents();

  console.log("data type: ", events);

  const selectedEvent = useMemo(
    () => events.find((e) => e.id === selectedEventId) ?? null,
    [events, selectedEventId],
  );

  return (
    <div className="flex-1 min-h-0 flex flex-col bg-[#1D2A52] relative">
      <FloatingLeftButton
        onClick={() => navigate({ to: "/home" })}
        className="absolute left-0 top-4 z-50"
        icon={
          <svg
            className="w-4 h-4"
            viewBox="0 0 9 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 1V0H2V1H1V2H0V3H1V4H2V5H3V4H6V7H3V8H7V7H8V6H9V3H8V2H7V1H3Z"
              fill="white"
            />
          </svg>
        }
      />
      <ResourceBar
        showBalance
        showMenu
        className="absolute top-3 left-14 right-4 flex z-20 pl-3"
      />

      <CalendarHeader />

      {selectedEvent ? (
        <div className="flex-1 min-h-0 overflow-y-auto">
          <EventDetail
            event={selectedEvent}
            onClose={() => setSelectedEventId(null)}
          />
        </div>
      ) : (
        <CalendarGrid
          events={events}
          weekOffset={weekOffset}
          onPrev={() => setWeekOffset((n) => n - 1)}
          onNext={() => setWeekOffset((n) => n + 1)}
          onSelectEvent={setSelectedEventId}
          isLoading={isLoading}
          isError={isError}
        />
      )}
    </div>
  );
}
